import { setTranslations } from '@adminsoft/ui/i18n';
import esTranslations from './es.json';

setTranslations(esTranslations);

export { t } from '@adminsoft/ui/i18n';
